import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import {
  Filter,
  FilterInput,
  FilterList,
  FilterOption
} from 'aquilla/core/molecules/Filter';

const StyledFilterInput = styled(FilterInput)`
  width: 100%;
`;

const StyledFilter = styled(Filter)`
  padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
  z-index: 1;
  grid-column: span 1;
`;

function getLabel(array: IFilter[], value: string): string {
  return array.find((menuItem) => menuItem.value === value)?.label || '';
}

interface IFilter {
  value: string;
  label: string;
}

interface FilterBlockProps {
  filterItems: IFilter[];
  filterItemOnClick: (newValue: string) => void;
  filterSelected: string;
  variant: 'topic' | 'course' | 'educator' | 'language';
}

export default function FilterBlock(props: FilterBlockProps) {
  const {
    filterItems,
    filterItemOnClick,
    filterSelected = 'all',
    variant
  } = props;
  return (
    <StyledFilter
      value={getLabel(filterItems, filterSelected)}
      onSelect={filterItemOnClick}
      placeholder={`All ${variant}s`}
    >
      <StyledFilterInput />
      <FilterList>
        {filterItems.map((item) => (
          <FilterOption
            value={item.value}
            label={item.label}
            key={item.value}
          />
        ))}
      </FilterList>
    </StyledFilter>
  );
}
